module.exports = __webpack_public_path__ + "static/media/207-307.9b21088e.png";